import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as appActions } from './app.reducer';

export const actions = formatActionTypeNames(
	{
		index: 'INDEX',
		modal: 'MODAL',
		setIndex: 'SET_INDEX',
		setFilters: 'SET_FILTERS',
	},
	'ASSET_VIEWER'
);

export const assetViewerActions = {
	index: createAction(actions.index),
	modal: createAction(actions.modal),
	setIndex: createAction(actions.setIndex),
	setFilters: createAction(actions.setFilters),
};

export default (state = initialState.assetViewer, action) => {
	const { payload } = action;

	switch (action.type) {

		case actions.setIndex:
			return {
				...state,
				index: {
					...state.index,
					...payload.index,
				},
				filters: {
					...state.filters,
					...payload.filters || {},
				},
			};

		case actions.setFilters:
			return {
				...state,
				page: payload.page || 0,
				type: payload.type || '',
			};

		// case actions.getUserComplete:
		// 	return {
		// 		...state,
		// 		user: payload.user,
		// 	};

		// case actions.signupComplete:
		// case actions.loginComplete:
		// 	return {
		// 		...state,
		// 		user: payload.user,
		// 	};

		// case actions.logoutComplete:
		// 	return initialState.auth;

		default:
			return state;
	}
};
